import { Megaphone, Sparkles } from 'lucide-react';

/**
 * AdCreditsCard — wide single-tile highlight showing the user's lifetime
 * 1SC3 Ad Credits balance. Display-only, read from the ``me`` prop. Sits
 * between the Position Activity Strip and the Wallet Cards on the
 * Member Dashboard.
 */
const fmtInt = (n) => {
  const v = Number(n || 0);
  if (!Number.isFinite(v)) return '0';
  return Math.round(v).toLocaleString('en-US');
};

const AdCreditsCard = ({ me }) => {
  if (!me) return null;
  const credits = Number(me.ad_credits_balance || 0);

  return (
    <section className="sc-glass rounded-2xl p-5 md:p-6 relative overflow-hidden" data-testid="ad-credits-card">
      <div
        className="absolute -top-16 -right-16 w-44 h-44 pointer-events-none rounded-full"
        style={{
          background: 'radial-gradient(circle, rgba(255,182,18,0.18), transparent 60%)',
        }}
        aria-hidden="true"
      />
      <div className="relative z-10 flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-4 min-w-0">
          <div
            className="w-12 h-12 rounded-xl flex items-center justify-center border shrink-0"
            style={{
              background: 'rgba(255,182,18,0.06)',
              borderColor: 'rgba(255,182,18,0.28)',
            }}
          >
            <Megaphone className="w-6 h-6 text-[#FFC20E]" />
          </div>
          <div className="min-w-0">
            <div className="text-[11px] uppercase tracking-[0.22em] text-[var(--sc-text-mute)]">1SC3 Ad Credits</div>
            <div className="sc-tabular font-display font-bold text-3xl md:text-4xl mt-1 leading-none sc-gold-text" data-testid="ad-credits-value">
              {fmtInt(credits)}
            </div>
          </div>
        </div>
        <div
          className="inline-flex items-center gap-2 px-3 py-2 rounded-lg border text-[11px] max-w-[280px]"
          style={{
            background: 'rgba(0,0,0,0.32)',
            borderColor: 'rgba(255,182,18,0.18)',
            color: 'var(--sc-text-mute)',
          }}
        >
          <Sparkles className="w-3.5 h-3.5 text-[#FFC20E] shrink-0" />
          <span className="leading-snug">Earn 1 credit per cent spent ($1 = 100 credits). Redeem 1:1 for banner impressions on the Advertise page.</span>
        </div>
      </div>
    </section>
  );
};

export default AdCreditsCard;
